import { GridFeeState, PowerPriceState } from 'src/Libs/dynamic-tariff-settings/dto'
import { DynamicTariffSettingsModel } from 'src/Libs/dynamic-tariff-settings/model'

/**
 * This function checks if the energy costs are dynamic based on the power price state and grid fee state.
 * Energy Cost is dynamic if powerPriceState is 'manual' or 'dynamic' or gridFeeState is 'variable'
 */
export const checkIsEnergyCostDynamic = (dynamicTariffSettings: DynamicTariffSettingsModel | null): boolean => {
  if (!dynamicTariffSettings) return false

  const { powerPriceState, gridFeeState } = dynamicTariffSettings
  const isPowerPriceDynamic = powerPriceState === PowerPriceState.Dynamic || powerPriceState === PowerPriceState.Manual
  const isGridFeeDynamic = gridFeeState === GridFeeState.Variable

  return isPowerPriceDynamic || isGridFeeDynamic
}
